(() => {
  'use strict';
  const configElement = document.getElementById('ThemeConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let drawer = document.getElementById('CartDrawer');
  let cartBusy = false;
  let addBusy = false;
  const cardFeedbackTimers = new WeakMap();
  let quickRequest;
  let statusTimer;
  const status = message => {
    const node = document.getElementById('StatusMessage');
    if (!node) return;
    node.textContent = message;
    node.classList.add('show');
    clearTimeout(statusTimer);
    statusTimer = setTimeout(() => node.classList.remove('show'), 6500);
  };
  const animate = (node, frames, duration = 210) => {
    if (reduced.matches || !node.animate) return Promise.resolve();
    return node.animate(frames, { duration, easing: 'cubic-bezier(.2,.7,.3,1)' }).finished.catch(() => {});
  };
  const openDialog = async (dialog, trigger) => {
    if (!dialog || dialog.open) return;
    dialog.returnFocus = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('dialog-open');
    trigger?.setAttribute('aria-expanded', 'true');
    await animate(dialog, [{ opacity: 0, transform: dialog === drawer ? 'translateX(35px)' : 'translateY(-12px)' }, { opacity: 1, transform: 'none' }]);
  };
  const closeDialog = async dialog => {
    if (!dialog?.open || dialog.dataset.closing) return;
    dialog.dataset.closing = 'true';
    await animate(dialog, [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: dialog === drawer ? 'translateX(35px)' : 'translateY(-12px)' }], 170);
    dialog.close();
    delete dialog.dataset.closing;
    document.documentElement.classList.remove('dialog-open');
    dialog.returnFocus?.setAttribute('aria-expanded', 'false');
    dialog.returnFocus?.focus();
  };
  const setupDialogs = () => {
  drawer = document.getElementById('CartDrawer');
  document.querySelectorAll('dialog').forEach(dialog => {
    if (dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(dialog); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(dialog);
    });
  });
  document.querySelectorAll('[data-open-shop]').forEach(trigger => {
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', 'ShopMenu');
    trigger.setAttribute('aria-expanded', 'false');
  });
  };
  setupDialogs();
  addEventListener('pageshow', event => { if (event.persisted && document.getElementById('cart')) location.reload(); });
  const setCartCount = count => document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = count; });
  const replaceDrawer = markup => {
    if (!markup || !drawer) return false;
    const doc = new DOMParser().parseFromString(markup, 'text/html');
    const body = doc.querySelector('[data-drawer-body]');
    if (!body) return false;
    drawer.querySelector('[data-drawer-body]').replaceWith(body);
    return true;
  };
  const refreshDrawer = async () => {
    const url = new URL(config.cart, location.origin);
    url.searchParams.set('sections', 'cart-drawer');
    const [sectionsResponse, cartResponse] = await Promise.all([
      fetch(url.toString()),
      fetch(`${config.cart}.js`, { headers: { Accept: 'application/json' } })
    ]);
    if (!sectionsResponse.ok || !cartResponse.ok) throw new Error(config.error);
    const [sections, cart] = await Promise.all([sectionsResponse.json(), cartResponse.json()]);
    setCartCount(cart.item_count);
    if (!replaceDrawer(sections['cart-drawer'])) throw new Error(config.error);
  };
  const openCart = async trigger => {
    if (!drawer) { location.assign(config.cart); return; }
    try {
      await refreshDrawer();
      await openDialog(drawer, trigger);
    } catch { location.assign(config.cart); }
  };
  const setCartBusy = busy => {
    cartBusy = busy;
    drawer?.setAttribute('aria-busy', String(busy));
    drawer?.querySelectorAll('input, [data-quantity-step]').forEach(node => { node.disabled = busy; });
  };
  const changeCart = async (key, quantity) => {
    if (cartBusy) return;
    const focused = document.activeElement;
    const focusKey = focused?.dataset?.lineKey || focused?.closest('.cart-line')?.querySelector('[data-line-key]')?.dataset.lineKey;
    setCartBusy(true);
    const message = drawer.querySelector('[data-drawer-message]');
    message.textContent = '';
    try {
      const response = await fetch(`${config.change}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'], sections_url: location.pathname })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(typeof cart.description === 'string' ? cart.description : config.error);
      setCartCount(cart.item_count);
      if (!replaceDrawer(cart.sections?.['cart-drawer'])) await refreshDrawer();
      const target = [...drawer.querySelectorAll('[data-line-key]')].find(node => node.dataset.lineKey === focusKey);
      if (target) target.disabled = false;
      (target || drawer.querySelector('[data-close-dialog]')).focus();
    } catch (error) {
      try { await refreshDrawer(); } catch {}
      const activeMessage = drawer.querySelector('[data-drawer-message]');
      if (activeMessage) activeMessage.textContent = error.message || config.error;
    } finally { setCartBusy(false); }
  };
  const openQuickAdd = async trigger => {
    const dialog = document.getElementById('QuickAddDialog');
    if (!dialog?.showModal || dialog.open) return;
    const body = dialog.querySelector('[data-quick-body]');
    quickRequest?.abort();
    const request = new AbortController();
    quickRequest = request;
    const loading = document.createElement('p');
    loading.className = 'quick-add-loading';
    loading.setAttribute('role', 'status');
    loading.textContent = body.dataset.loading;
    body.replaceChildren(loading);
    body.setAttribute('aria-busy', 'true');
    dialog.addEventListener('close', () => request.abort(), { once: true });
    await openDialog(dialog, trigger);
    try {
      const url = new URL(trigger.href, location.origin);
      url.searchParams.set('section_id', 'quick-add-product');
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error(config.error);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-quick-add-content]');
      if (!content) throw new Error(config.error);
      if (request.signal.aborted || !dialog.open) return;
      body.replaceChildren(content);
      if (dialog.contains(document.activeElement)) body.querySelector('select')?.focus();
    } catch (error) {
      if (request.signal.aborted) return;
      const message = document.createElement('p');
      message.setAttribute('role', 'alert');
      message.textContent = config.error;
      const link = document.createElement('a');
      link.href = trigger.href;
      link.textContent = trigger.closest('article')?.querySelector('h3')?.textContent || config.unavailable;
      link.className = 'quick-add-details';
      body.replaceChildren(message, link);
    } finally { if (quickRequest === request) body.removeAttribute('aria-busy'); }
  };
  document.addEventListener('click', event => {
    const quick = event.target.closest('[data-quick-add]');
    if (quick && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && document.getElementById('QuickAddDialog')?.showModal) {
      event.preventDefault(); openQuickAdd(quick); return;
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) { closeDialog(close.closest('dialog')); return; }
    const shop = event.target.closest('[data-open-shop]');
    if (shop && document.getElementById('ShopMenu')?.showModal) { event.preventDefault(); openDialog(document.getElementById('ShopMenu'), shop); return; }
    const cart = event.target.closest('[data-open-cart]');
    if (cart && !document.getElementById('cart') && drawer?.showModal) { event.preventDefault(); openCart(cart); return; }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); if (!cartBusy) changeCart(remove.dataset.cartRemove, 0); return; }
    const step = event.target.closest('[data-quantity-step]');
    if (step) {
      const input = step.closest('.quantity-control').querySelector('input');
      if (input.disabled) return;
      const old = input.value;
      Number(step.dataset.quantityStep) > 0 ? input.stepUp() : input.stepDown();
      if (old !== input.value) input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const imageLink = event.target.closest('[data-gallery-image]');
    if (imageLink) {
      const container = imageLink.closest('.product-gallery').querySelector('[data-product-image]');
      const image = document.createElement('img');
      image.src = imageLink.dataset.galleryImage;
      image.alt = imageLink.dataset.imageAlt || document.querySelector('.product-details h1')?.textContent || '';
      image.width = image.height = 1200;
      container.replaceChildren(image);
      event.preventDefault();
    }
  });
  document.addEventListener('change', event => {
    const quickSelect = event.target.closest('[data-quick-variant]');
    if (quickSelect) {
      const option = quickSelect.selectedOptions[0];
      const content = quickSelect.closest('[data-quick-add-content]');
      const price = content.querySelector('[data-quick-price]');
      const strong = document.createElement('strong'); strong.textContent = option.dataset.price;
      price.replaceChildren(strong);
      if (option.dataset.compare) { const compare = document.createElement('s'); compare.textContent = option.dataset.compare; price.append(compare); }
      if (option.dataset.unitPrice) { const unit = document.createElement('span'); unit.className = 'unit-price'; unit.textContent = option.dataset.unitPrice; price.append(unit); }
      content.querySelector('[name="add"]').disabled = option.dataset.available !== 'true';
      const input = content.querySelector('[name="quantity"]');
      input.min = option.dataset.min || 1; input.step = option.dataset.step || 1;
      if (option.dataset.max) input.max = option.dataset.max; else input.removeAttribute('max');
      input.value = input.min;
      content.querySelector('[data-form-message]').textContent = '';
      if (option.dataset.image) {
        const image = document.createElement('img'); image.src = option.dataset.image;
        image.alt = content.querySelector('h3').textContent; image.width = image.height = 360;
        content.querySelector('[data-quick-image]').replaceChildren(image);
      }
      return;
    }
    const quantity = event.target.closest('[data-cart-quantity]');
    if (quantity) {
      if (!quantity.checkValidity()) { quantity.reportValidity(); return; }
      changeCart(quantity.dataset.lineKey, Number(quantity.value));
    }
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const panel = select.closest('[data-product-details]');
    const price = panel.querySelector('[data-variant-price]');
    price.replaceChildren();
    const strong = document.createElement('strong');
    strong.textContent = option.dataset.price;
    price.append(strong);
    if (option.dataset.compare) {
      const compare = document.createElement('s'); compare.textContent = option.dataset.compare; price.append(' ', compare);
    }
    if (option.dataset.unitPrice) {
      const unit = document.createElement('span'); unit.className = 'unit-price'; unit.textContent = option.dataset.unitPrice; price.append(unit);
    }
    const ingredients = panel.querySelector('[data-product-ingredients]');
    if (ingredients) {
      const text = option.dataset.ingredients || '';
      ingredients.querySelector('[data-ingredient-text]').textContent = text;
      ingredients.hidden = !text.trim();
    }
    const available = option.dataset.available === 'true';
    const button = panel.querySelector('[name="add"]');
    button.disabled = !available;
    button.textContent = available ? config.addLabel : config.soldOut;
    panel.querySelector('[data-variant-stock]').textContent = available ? config.available : config.soldOut;
    const input = panel.querySelector('[name="quantity"]');
    input.min = option.dataset.min || 1; input.step = option.dataset.step || 1;
    if (option.dataset.max) input.max = option.dataset.max; else input.removeAttribute('max');
    input.value = input.min;
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
    if (option.dataset.image) {
      const image = document.createElement('img'); image.src = option.dataset.image; image.alt = panel.querySelector('h1').textContent; image.width = image.height = 1200;
      panel.closest('.product-layout').querySelector('[data-product-image]').replaceChildren(image);
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !drawer?.showModal) return;
    event.preventDefault();
    if (form.dataset.busy || addBusy || cartBusy || !form.reportValidity()) return;
    addBusy = true;
    form.dataset.busy = 'true';
    const button = form.querySelector('[name="add"]');
    const wasDisabled = button.disabled;
    const message = form.querySelector('[data-form-message]');
    const cardForm = form.classList.contains('card-quick-form');
    if (cardForm) {
      clearTimeout(cardFeedbackTimers.get(form));
      cardFeedbackTimers.delete(form);
      delete form.dataset.added;
    }
    const body = new FormData(form);
    body.set('sections', 'cart-drawer'); body.set('sections_url', location.pathname);
    const controls = [...form.querySelectorAll('select, input, [data-quantity-step]')].map(node => [node, node.disabled]);
    controls.forEach(([node]) => { node.disabled = true; });
    button.disabled = true; form.setAttribute('aria-busy', 'true'); message.textContent = '';
    let added = false;
    try {
      const response = await fetch(`${config.add}.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : config.error);
      added = true;
      message.textContent = config.added;
      if (cardForm) {
        form.dataset.added = 'true';
        cardFeedbackTimers.set(form, setTimeout(() => {
          delete form.dataset.added;
          message.textContent = '';
          cardFeedbackTimers.delete(form);
        }, 2000));
      }
      if (replaceDrawer(data.sections?.['cart-drawer'])) {
        const cartResponse = await fetch(`${config.cart}.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(config.error);
        setCartCount((await cartResponse.json()).item_count);
      } else { await refreshDrawer(); }
      const quickDialog = form.closest('#QuickAddDialog');
      const returnFocus = quickDialog?.returnFocus || button;
      if (quickDialog) await closeDialog(quickDialog);
      if (document.getElementById('cart')) { location.assign(config.cart); return; }
      await openDialog(drawer, returnFocus);
    } catch (error) {
      message.textContent = added ? config.added : (error.message || config.error);
      if (!cardForm) {
        const link = document.createElement('a'); link.href = config.cart; link.textContent = config.viewCart;
        message.append(' ', link);
      }
      status(added ? config.added : (error.message || config.error));
    } finally {
      controls.forEach(([node, wasDisabled]) => { node.disabled = wasDisabled; });
      delete form.dataset.busy; form.removeAttribute('aria-busy');
      addBusy = false;
      const variantSelect = form.querySelector('[data-variant-select], [data-quick-variant]');
      button.disabled = variantSelect ? variantSelect.selectedOptions[0]?.dataset.available !== 'true' : wasDisabled;
    }
  });
  const setupMotion = () => document.querySelectorAll('[data-country-motion]').forEach(control => {
    if (control.dataset.initialized) return; control.dataset.initialized = 'true';
    const word = control.closest('.floral-image').querySelector('[data-country-word]');
    const words = control.dataset.countries.split(',').map(value => value.trim()).filter(Boolean);
    let paused = false, index = 0;
    const update = () => {
      const stopped = paused || reduced.matches;
      control.setAttribute('aria-pressed', String(stopped));
      control.setAttribute('aria-label', stopped ? config.resume : config.pause);
      control.firstElementChild.textContent = stopped ? '▷' : 'Ⅱ';
    };
    control.addEventListener('click', () => { paused = !paused; update(); });
    reduced.addEventListener('change', update); update();
    const timer = setInterval(async () => {
      if (!word.isConnected) { clearInterval(timer); reduced.removeEventListener('change', update); return; }
      if (paused || reduced.matches || document.hidden || words.length < 2 || !word.isConnected) return;
      const box = word.getBoundingClientRect();
      if (box.bottom < 0 || box.top > innerHeight) return;
      await animate(word, [{ opacity: 1 }, { opacity: 0 }], 180);
      if (paused || reduced.matches) return;
      index = (index + 1) % words.length; word.textContent = words[index];
      await animate(word, [{ opacity: 0 }, { opacity: 1 }], 180);
    }, 3800);
  });
  setupMotion();
  const setupCountries = () => document.querySelectorAll('[data-country-select]').forEach(country => {
    if (country.dataset.initialized) return; country.dataset.initialized = 'true';
    const province = document.getElementById(country.dataset.provinceId);
    const update = () => {
      let values = []; try { values = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch {}
      province.replaceChildren(...values.map(([code, name]) => new Option(name, name, false, name === province.dataset.default || code === province.dataset.default)));
      province.disabled = !values.length;
    };
    const value = country.dataset.default || 'United States';
    [...country.options].forEach(option => { option.selected = option.value === value || option.textContent === value; });
    if (country.selectedIndex < 0) country.selectedIndex = 0;
    country.addEventListener('change', update); update();
  });
  setupCountries();
  const setupFaq = () => {
  const faq = document.getElementById('faqSearch');
  if (faq && !faq.dataset.initialized) {
    faq.dataset.initialized = 'true';
    const input = document.getElementById('faqQuery'), clear = document.getElementById('clearFaq');
    const items = [...document.querySelectorAll('.faq-item')], groups = [...document.querySelectorAll('.faq-group')];
    const normalize = text => text.toLowerCase().normalize('NFKD').replace(/\p{M}/gu, '').replace(/weighed|weighted/g, 'weight').replace(/pick[ -]?up/g, 'pickup').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    let saved;
    const filter = () => {
      const tokens = normalize(input.value).split(' ').filter(Boolean);
      if (tokens.length && !saved) saved = new Set(items.filter(item => item.open));
      let count = 0;
      items.forEach(item => {
        item.hidden = !tokens.every(token => normalize(item.textContent).includes(token));
        if (!item.hidden) count++;
        if (tokens.length && !item.hidden) item.open = true;
        else if (!tokens.length && saved) item.open = saved.has(item);
      });
      if (!tokens.length) saved = undefined;
      groups.forEach(group => { group.hidden = ![...group.querySelectorAll('.faq-item')].some(item => !item.hidden); });
      clear.hidden = !input.value; document.getElementById('faqEmpty').hidden = count > 0;
      document.getElementById('faqStatus').textContent = input.value ? config.faqResults.replace('[count]', count) : '';
    };
    const reset = () => { input.value = ''; filter(); input.focus(); };
    faq.hidden = false; faq.addEventListener('submit', event => { event.preventDefault(); filter(); });
    input.addEventListener('input', filter); clear.addEventListener('click', reset); document.getElementById('resetFaq')?.addEventListener('click', reset);
    document.querySelectorAll('.faq-topic-nav a').forEach(link => link.addEventListener('click', () => { if (document.getElementById(link.hash.slice(1))?.hidden) reset(); }));
    const openHash = () => { const target = document.getElementById(location.hash.slice(1)); if (target?.matches('.faq-item')) target.open = true; };
    addEventListener('hashchange', openHash); openHash();
  }
  };
  setupFaq();
  document.addEventListener('shopify:section:load', () => { setupDialogs(); setupCountries(); setupMotion(); setupFaq(); });
})();
